import { Media } from '../tests/entity';
import { TestFormValues } from '@app.raytd.com/common/types/test-form';

/**
 * Base properties shared between creating and updating a TestItem.
 */
export interface TestItemBase {
  assessment_id: number | string;
  test_specification_id?: number | string;
  assetId?: number;

  // --- Location Fields ---
  building_id?: (number | string) | null;
  level_id?: (number | string) | null;
  area?: (number | string) | null; // Corresponds to 'rooms,id'

  // --- Core Data ---
  status?: string;
  result?: string | null;
  observations?: string | null;
  recommendations?: string | null;
  formId?: string;
  custom?: Record<string, any> | null;

  // --- Element Fields ---
  element_id?: string | null;
  element_name?: string | null;
  element_classification_id?: number | null;

  // --- Media ---
  images?: Partial<Media>[];
}

/**
 * API request payload for updating an existing TestItem.
 * (Based on the 'updateTestItem' method)
 */
export interface TestItemUpdateRequest extends TestItemBase {
  // --- Special toggle fields for updates ---
  fast_fill_accepted?: boolean;
  fastFillChanged?: any[];
}

export const convertTestItemToServerPayload = (
  testItem: TestFormValues
): TestItemBase => {
  return {
    assessment_id: testItem.assessmentId,
    test_specification_id: testItem.test_specification_id,
    assetId: testItem.assetId,
    building_id: testItem.building_id,
    level_id: testItem.level_id,
    area: testItem.area_id,
    status: testItem.status,
    result: testItem.result,
    observations: testItem.observations,
    recommendations: testItem.recommendations,
    // formId: ,
    custom: testItem.custom,
    element_id: testItem.element_id,
    element_name: testItem.element_name,
    element_classification_id: testItem.element,
    images: testItem.images,
  };
};
